import { InjectionToken, Provider } from '@angular/core'
import { environment } from '../../environments/environment'

export const gameSetupSiteBaseUrlToken = new InjectionToken<string>(
  'GameSetupSiteBaseUrlToken',
)

export const gameSetupSiteBaseUrlProvider: Provider = {
  provide: gameSetupSiteBaseUrlToken,
  useValue: environment.gameSetupSiteBaseUrl,
}
